// eslint-disable-next-line @nx/enforce-module-boundaries
import { Antrag } from '../types';
import { Deferred, MessageBase } from '@ebeihilfe/core';
import { EinreichungService } from '../services';
import { EinreichungStep } from '../enums';
import { EinreichungStepResultType } from '../interfaces';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export abstract class ClosingScreenBase {
  public antrag!: Antrag;
  public prio = EinreichungStep.COMPLETE;
  protected work!: Deferred<EinreichungStepResultType>;

  protected constructor(
    protected translate: TranslateService,
    protected message: MessageBase,
    protected einreichungService: EinreichungService,
  ) {}

  public canHandle(antrag: Antrag): boolean | Promise<boolean> {
    return antrag.isComplete || antrag.doNotFinishMe;
  }

  public destroy(): Promise<void> {
    return Promise.resolve();
  }

  public finishWithRouting(route?: string): void {
    this.work.resolve({
      result: this.antrag,
      shouldProceed: false,
      navigateTo: route,
    });
  }

  public hasUi(): boolean {
    return true;
  }
}
